exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "button[data-v-2af471f5]:disabled{background:#acacac;opacity:.4;color:#000;cursor:not-allowed}", ""]);

// exports
